import Skeleton from "@mui/material/Skeleton";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

interface TableSkeletonRowsProps {
  /** As many rows as the page will hold, so the table does not resize when data lands. */
  rowCount: number;
  columnCount: number;
}

/** Placeholder rows for either รายงานการโอน table while its page is loading. */
export default function TableSkeletonRows({
  rowCount,
  columnCount,
}: TableSkeletonRowsProps) {
  return (
    <>
      {Array.from({ length: rowCount }).map((_, rowIndex) => (
        <TableRow key={rowIndex}>
          {Array.from({ length: columnCount }).map((__, columnIndex) => (
            <TableCell key={columnIndex}>
              <Skeleton variant="text" />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
}
